module.exports = __webpack_public_path__ + "static/media/card-direct-deposit.532e4a97.svg";